module.exports = __webpack_public_path__ + "static/media/imageryAndLaboratoryOffices.69edce8a.jpg";